import { Component, Input, OnInit, OnDestroy, transition, animate, trigger, state, style, Output, EventEmitter } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Menu } from '../../models/Menu';
import { Subscription } from 'rxjs/Subscription';
import { MenuService } from '../../services/MenuService';
import { Admin } from '../../../admin/models/Admin';
import { AdminService } from '../../../admin/services/AdminService';
import { SessionService } from '../../../admin/services/SessionService';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'admin-sidebar',
  template: require('./AdminSidebarComponent.html'),
  styles: [require('./AdminSidebarComponent.sass')],
  animations: [
    trigger('toggleSidebar', [
      state('inactive', style({
        width: '70px',
      })),
      state('active', style({
        width: '100%',
      })),
      transition('inactive => active', animate('200ms ease-in')),
      transition('active => inactive', animate('200ms ease-out'))
    ]),
    trigger('toggleText', [
      state('inactive', style({
        width: '0',
        height: '0',
        opacity: '0',
      })),
      state('active', style({ 
        width: '*',
        height: '*',
        opacity: '1',
      })),
      transition('inactive => active', animate('200ms ease-in')),
      transition('active => inactive', animate('200ms ease-out'))
    ])
  ]
})

export class AdminSidebarComponent implements OnInit, OnDestroy {
  @Input() module: string;
  @Output() hideMenu: EventEmitter<any> = new EventEmitter();

  private sidebar: Menu[];
  private subscription: Subscription;
  private adminData: Admin;
  private loggedIn: boolean;
  private sidebarStatus: boolean;
  private show: boolean;

  message: string;
  messageType: string;
  isSmall: boolean = false;
  isShowText: boolean = false;

  constructor(private translate: TranslateService,
    private menuService: MenuService,
    private adminService: AdminService,
    protected sessionService: SessionService) {

  }

  toggleSmallSidebard(){
    this.isSmall = !this.isSmall;
    this.hideMenu.emit(this.isShowText);
  }

  animationDone(event: any){
    if(event.fromState == "inactive"){
      this.isShowText = !this.isShowText;
    }
  }

  animationStart(event: any){
    if(event.fromState == "active"){
      this.isShowText = !this.isShowText;
    }
  }


  ngOnInit() {
    this.getSession();

    // Get Sidebar menu list
    let sidebarName = this.getSidebarName(this.module);
    this.sidebar = this.menuService.getMenuList(sidebarName);

    this.subscription = this.adminService.adminDataChanged$.subscribe(
      admin => {
        this.onSessionChanged(admin);
      }
    );




    if (sidebarName == "bus-admin-sidebar") {
      this.sidebar.forEach(e => {
        if (e.id == "bus-schedule")
          e.label = 'DATA_MENU_DAILY_TRANSPORT_LIST';
        else if (e.id == "bus-student-management")
          e.label = 'DATA_MENU_STUDENT_REPORT';
        else if (e.id == "bus-report")
          e.label = 'DATA_MENU_BUS_REPORT';
        else if (e.id == "bus-settings")
          e.label = 'DATA_MENU_SETTINGS';
      });
    }

  }

  ngOnDestroy() {
    // Destroy the subscription for session changes
    this.subscription.unsubscribe();
  }

  /**
   * Action that fired when the session change event is catched.
   * Update the adminData & the menuList.
   */
  private onSessionChanged(admin: Admin) {
    //TO DO: update menu content when session changed
    this.adminData = admin;
  }

  private getSidebarStatus() {
    if (!this.adminData) {
      return false
    }
    else {
      return true
    }
  }

  private getSidebarName(moduleName: string): string {
    let sidebarName = "";
    switch (moduleName) {
      case "camp":
        sidebarName = "camp-admin-sidebar";
        break;
      case "asa":
        sidebarName = "asa-admin-sidebar";
        break;
      case "bus":
        sidebarName = "bus-admin-sidebar";
        break;
      case "holiday":
        sidebarName = "holiday-admin-sidebar";
        break;
      case "reen":
        sidebarName = "reen-admin-sidebar";
        break;
      default:
        break;
    }
    return sidebarName;
  }

  // Check user role to show/hide option
  accessible(role: string) {
    if (!role.length) {
      return true;
    }
    return role.indexOf(this.adminData.role) !== -1 ? true : false;
  }

  private getSession(): void {
    this.sessionService.getSession()
      .subscribe(
        admin => {
          this.adminData = admin
          this.sidebarStatus = this.getSidebarStatus();
        },
        error => {
          //TO DO: Handle any error if needed in the furture
          this.message = "";
          this.messageType = "alert";
        }
      );
  }
}


// WEBPACK FOOTER //
// ./src/common/modules/core/components/admin-sidebar/AdminSidebarComponent.ts